/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  editTaxCompliantAccountDetails,
  resetTaxEditDetails,
} from "../../../../../redux/features/accounts/taxAccount/taxAccountCreateEdit";
import { taxCompliantAccountDetail } from "../../../../../redux/features/accounts/taxAccount/taxAccountDetails";
import Validation from "../../../../../utils/validation";

const TaxationAccountEditContact = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [updateActive, setUpdateActive] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(true);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);
  const [, setIsMobile] = useState(window.innerWidth <= 1024);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
  });

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const { taxAccountEditOtherDetailsData } = useSelector(
    (state) => state.taxCompliantAccounts,
  );
  const { taxCompliantDetailsData, taxCompliantDetailsLoading } = useSelector(
    (state) => state.taxCompliantAccountDetail,
  );

  const handleBack = () => {
    if (!nextButtonEnabled) {
      setOpenEditContactPop(true);
    } else {
      navigate(-1);
    }
  };

  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    handleUpdateLegalName(event.target.value);
  };
  const handleDivBtn = (value) => {
    setSelectedValue(value);
    handleUpdateLegalName(value);
  };

  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]+$/;

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    } else if (type === "account_name") {
      return value;
    } else {
      return value.trim();
    }
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "account_name")
      errors = Validation.validateAccountName(name, value, errors);
    setCustomErrors(errors);
  };

  const checkAllValidations = () => {
    return contactNumberValidation && emailValidation;
  };

  const handleUpdateLegalName = (value) => {
    const taxAccountData = taxCompliantDetailsData?.tds_accounts?.[0];

    setPayload((prevPayload) => {
      if (value === "legalname") {
        return {
          ...prevPayload,
          account_name: taxAccountData?.name || "",
        };
      }

      if (value === "customname") {
        const keepCurrent =
          prevPayload.account_name &&
          prevPayload.account_name.trim().length > 0 &&
          prevPayload.account_name.trim().toLowerCase() !==
            (taxAccountData?.pan_legal_name || "").trim().toLowerCase();

        return {
          ...prevPayload,
          account_name: keepCurrent
            ? prevPayload.account_name
            : taxAccountData?.name || "",
        };
      }

      return prevPayload;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(
      name,
      name !== "account_name" ? value.replace(/[^a-zA-Z0-9@.]/g, "") : value,
    );

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value.length === 1) {
        return;
      }
      if (name === "contact_no") {
        if (
          name === "contact_no" &&
          (newValue.length === 0 || newValue.length < 10)
        ) {
          setContactNumberValidation(false);
        } else {
          setContactNumberValidation(true);
        }
      }
      if (name === "email_id") {
        if (
          name === "email_id" &&
          (newValue.length === 0 || !emailRegex.test(newValue))
        ) {
          setEmailValidation(false);
        } else {
          setEmailValidation(true);
        }
      }
      if (name === "account_name") {
        if (name === "account_name" && newValue.length === 0) {
          setAccountNameValidation(false);
        } else {
          setAccountNameValidation(true);
        }
        if (
          newValue === taxCompliantDetailsData?.tds_accounts[0]?.pan_legal_name
        ) {
          setSelectedValue("legalname");
        }
      }
    }
  };

  useEffect(() => {
    if (taxAccountEditOtherDetailsData) {
      const taxAccountData = taxCompliantDetailsData?.tds_accounts?.[0];

      const updatedFields = [];

      if (taxAccountData?.contact_no !== payload.contact_no) {
        updatedFields.push("contact_no");
      }

      if (
        (taxAccountData?.email_id || "").toLowerCase().trim() !==
        (payload.email_id || "").toLowerCase().trim()
      ) {
        updatedFields.push("email_id");
      }

      if (
        (taxAccountData?.name || "").trim() !==
        (payload.account_name || "").trim()
      ) {
        updatedFields.push("account_name");
      }

      navigate(
        `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/contact_edit_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > 0
                ? updatedFields
                : ["contact_no", "email_id", "account_name"],
          },
        },
      );

      dispatch(resetTaxEditDetails());
    }
  }, [taxAccountEditOtherDetailsData]);

  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(taxCompliantAccountDetail(id));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    if (
      !taxCompliantDetailsLoading &&
      taxCompliantDetailsData?.status === true
    ) {
      const taxAccountData = taxCompliantDetailsData?.tds_accounts[0];

      if (taxAccountData) {
        console.log("SENDING:", {
          email: payload.email_id,
          contact_no: payload.contact_no,
          name: payload.account_name,
        });
        setPayload((prevPayload) => ({
          ...prevPayload,
          contact_no: taxAccountData.contact_no,
          email_id: taxAccountData.email_id,
          account_name: taxAccountData.name, // ✅ THIS IS THE FIX
        }));
      }
      if (taxAccountData?.name === taxAccountData?.name) {
        setSelectedValue("legalname");
      } else {
        setSelectedValue("customname");
      }
    }
  }, [taxCompliantDetailsData, taxCompliantDetailsLoading, dispatch]);

  useEffect(() => {
    setContactNumberValidation(
      Validation.allowedContactNum(payload.contact_no),
    );
    setEmailValidation(Validation.allowedEmail(payload.email_id));
  }, [payload.contact_no, payload.email_id]);

  useEffect(() => {
    if (customErrors["contact_no"]) setContactNumberValidation(false);
    if (!customErrors["contact_no"] && payload.contact_no?.length === 10)
      setContactNumberValidation(true);
    if (customErrors["email_id"]) setEmailValidation(false);
    if (
      !customErrors["email_id"] &&
      payload.email_id?.length > 0 &&
      emailRegex.test(payload.email_id)
    )
      setEmailValidation(true);
    if (customErrors["account_name"]) setAccountNameValidation(false);
    if (!customErrors["account_name"] && payload.account_name.length > 0)
      setAccountNameValidation(true);
  }, [customErrors]);

  useEffect(() => {
    if (taxAccountEditOtherDetailsData?.status === true) {
      const taxAccountData = taxCompliantDetailsData?.tds_accounts?.[0];
      const updatedFields = [];
      if (taxAccountData?.contact_no !== payload.contact_no) {
        updatedFields.push("contact_no");
      }
      if (
        (taxAccountData?.email_id || "").toLowerCase().trim() !==
        (payload.email_id || "").toLowerCase().trim()
      ) {
        updatedFields.push("email_id");
      }
      if (
        (taxAccountData?.name || "").trim() !==
        (payload.account_name || "").trim()
      ) {
        updatedFields.push("account_name");
      }
      navigate(
        `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/contact_edit_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > 0
                ? updatedFields
                : ["contact_no", "email_id", "account_name"],
          },
        },
      );
      dispatch(resetTaxEditDetails());
    }
  }, [taxAccountEditOtherDetailsData]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsEnabled: !nextButtonEnabled && !updateActive,
      previousIsDisabled: updateActive,
      nextIsLoading: updateActive,
      nextLoaderNeeded: true,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: updateActive
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-primary)",
      stepperText: "Contact details",
    },
  ];

  const handleEditUpdateAccount = async () => {
    if (updateActive) return;

    try {
      setUpdateActive(true);
      await dispatch(
        editTaxCompliantAccountDetails({
          id,
          requestBody: {
            email: payload.email_id.toLowerCase(),
            contact_no: payload.contact_no,
            name: payload.account_name,
          },
        }),
      );
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setUpdateActive(false);
    }
  };

  const handleConfirm = () => {
    navigate(
      `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${id}`,
    );
  };

  return (
    <>
      {!nextButtonEnabled && openEditContactPop && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Are you sure you want to leave this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenEditContactPop(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="Qlg:hidden sticky top-top-base z-z-index-header">
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavSubText="Edit Tax Account"
            topNavHeader="Contact details"
          />
        </div>
        <div
          className="flex flex-col items-center justify-start max-w-tab-width-normal mx-auto my-margin-base w-full bg-primary-nav rounded-b-border-radius-md"
          style={{
            overflow: !nextButtonEnabled && openEditContactPop ? "hidden" : "",
          }}
        >
          <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="flex justify-center items-end !bottom-bottom-base Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleEditUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
        </div>

        <div className="flex flex-row h-full-height max-w-tab-width-normal mx-auto w-full flex-1">
          <div className="w-full">
            <div className="w-width-full px-padding-md Qlg:px-padding-base Qmd:gap-gap-xl flex flex-col gap-gap-md Qmd:flex-row h-fit pt-padding-md">
              <div className="flex flex-col relative w-full rounded-border-radius-md">
                <AccountName
                  handleChange={handleChange}
                  accountNameValidation={accountNameValidation}
                  accountName={payload.account_name}
                  placeHolder={"Account name"}
                  selectedValue={selectedValue}
                  handleDivBtn={handleDivBtn}
                  handleRadioBtn={handleRadioBtn}
                  selectedRadioValue={selectedValue}
                  legalName={taxCompliantDetailsData?.tds_accounts?.[0]?.name}
                  nameSubLabel="Autogenerate account name"
                />
              </div>
              <div className="flex flex-col relative rounded-border-radius-md w-full">
                <ContactDetails
                  handleChange={handleChange}
                  contactNumberValidation={contactNumberValidation}
                  emailValidation={emailValidation}
                  contactNumber={payload.contact_no}
                  emailId={payload.email_id}
                  selectedValue={selectedValue}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxationAccountEditContact;
